import axios from 'axios';

import { getApiEndPoint } from '../helpers/apibase';
import { mapServerError } from './utils/serverErrorMapper';

const baseURL = getApiEndPoint();
const portalApi = axios.create({
  baseURL: `${baseURL}/communication`,
  withCredentials: true,
});

export const getIntercomJwt = async (): Promise<string> => {
  try {
    const response = await portalApi.get<{ token: string }>(`/intercom/jwt`);

    return response.data.token;
  } catch (error) {
    const err = await mapServerError(error);
    throw err;
  }
};

export const updateIntercomCompany = async (
  orgId: string,
  body: {
    orgName: string;
  }
): Promise<void> => {
  try {
    await portalApi.post(`/org/${orgId}/intercom/company`, body);
  } catch (error) {
    const err = await mapServerError(error);
    throw err;
  }
};
